import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';

import DropdownList from 'settings/page-elements/dropdown/DropdownList';

import CN from './DropdownServiceWithoutSwitcher.module.scss';

const DropdownServiceWithoutSwitcher = ({
  subName,
  isOffline,
  parentItems,
  childItemsPropName,
  childItemCheckPropName,
  onCheckboxClick,
  isDarkMode,
}) => {
  const { t } = useTranslation();

  const componentClasses = cn({
    [CN.component]: true,
    [CN.darkMode]: isDarkMode,
  });

  const offlineClasses = cn({
    [CN.dropdownList]: true,
    [CN.offline]: isOffline,
  });

  return (
    <div data-bem="DropdownServiceWithoutSwitcher" className={componentClasses}>
      <div className={CN.text}>{subName}</div>
      <div className={offlineClasses}>
        <div className={CN.dropdownHeader}>
          <div>{t('onlineBooking.generalSettings.businessOnlineHours.dropdownNoSwitcher.daysHours')}</div>
          <div>{t('onlineBooking.generalSettings.businessOnlineHours.dropdownNoSwitcher.status')}</div>
        </div>

        {parentItems.map((item) => (
          <DropdownList
            items={item[childItemsPropName]}
            childItemCheckPropName={childItemCheckPropName}
            onCheckboxClick={onCheckboxClick}
            key={item.id}
            showSwitcher={false}
            variant="hours"
          />
        ))}
      </div>
    </div>
  );
};

const DropdownServiceWithoutSwitcherHoc = withTheme()(DropdownServiceWithoutSwitcher);

export default DropdownServiceWithoutSwitcherHoc;
